import { ToastContainer } from '@iguanads/react'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import React from 'react'

import { PickupOrderReminders } from '@/components/pickup-order-reminders'
import { queryClient } from '@/lib/react-query'

import { AudioProvider } from './AudioContext'
import { AuthProvider } from './AuthContext'
import { FrontChatProvider } from './front-chat-context'
import { LiveOrdersProvider } from './live-orders-context'

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <AudioProvider>
          <LiveOrdersProvider>
            <FrontChatProvider>
              {children}

              <PickupOrderReminders />
              <ToastContainer />
            </FrontChatProvider>
          </LiveOrdersProvider>
        </AudioProvider>
      </AuthProvider>

      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}

export function PublicProviders({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AudioProvider>
        <LiveOrdersProvider>
          {children}

          <ToastContainer />
        </LiveOrdersProvider>
      </AudioProvider>

      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}
